import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TeamState = {
  dataAllTeams: TeamType[];
  pagination: PaginationAPI;
  totalElements?: number;
  freeUsers: any[];
  managers: ManagerTeamType[];
  teamMembers: TeamMemberType[];
  teamDetail?: TeamType;
};

export const teamInitialState: TeamState = {
  dataAllTeams: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  freeUsers: [],
  managers: [],
  teamMembers: [],
};

export const slice = createSlice({
  name: 'team',
  initialState: teamInitialState,
  reducers: {
    setListTeamAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: TeamType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllTeams = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
    addTeamAction(state, { payload }: PayloadAction<TeamType>) {
      state.dataAllTeams.unshift(payload);
      if (state.totalElements !== undefined) {
        state.totalElements += 1;
      }
    },
    updateTeamAction(state, { payload }: PayloadAction<Partial<TeamType> & { teamId: string }>) {
      const teamIndex = state.dataAllTeams.findIndex((team) => team.teamId === payload.teamId);
      if (teamIndex >= 0) {
        state.dataAllTeams[teamIndex] = {
          ...state.dataAllTeams[teamIndex],
          ...payload,
        };
      }
      if (state.teamDetail?.teamId === payload.teamId) {
        state.teamDetail = {
          ...state.teamDetail,
          ...payload,
        };
      }
    },
    setTeamDetailAction(state, { payload }: PayloadAction<TeamType | undefined>) {
      state.teamDetail = payload;
    },
    setFreeUsersAction(state, { payload }: PayloadAction<any[]>) {
      state.freeUsers = payload;
    },
    setManagersAction(state, { payload }: PayloadAction<ManagerTeamType[]>) {
      state.managers = payload;
    },
    setTeamMembersAction(state, { payload }: PayloadAction<TeamMemberType[]>) {
      state.teamMembers = payload;
    },
  },
});

export const {
  setListTeamAction,
  addTeamAction,
  updateTeamAction,
  setTeamDetailAction,
  setFreeUsersAction,
  setManagersAction,
  setTeamMembersAction,
} = slice.actions;

export default slice.reducer;
